import axios from 'src/utils/axios';
import { API_BASE_URL } from 'src/config';

export const GET_PRODUCTS = '@recipes/get-recipes';
export const REQUEST_PRODUCTS = '@recipes/request-recipes';

export function getRecipes(page = 1, pagesize = 10, orderby = '', orderdirection = '', filter = null) {
  const params = {
    page,
    orderby,
    orderdirection
  };

  if (pagesize > 0) {
    params.pagesize = pagesize;
  }

  if (filter != null) {
    if (filter.category_id != null) {
      params.category_id = filter.category_id;
    }

    if (filter.query != null) {
      params.query = filter.query;
    }
  }

  const request = axios.get(`${API_BASE_URL}/recipe`, { params });

  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCTS });

    request
      .then((response) =>
        dispatch({
          type: GET_PRODUCTS,
          payload: { recipes: response.data.data, total: response.data.total }
        })
      )
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = error.response.data;
        }
        dispatch({
          type: GET_PRODUCTS,
          payload: { recipes: [], total: 0, message }
        });
      });
  };
}
